export default "__VITE_ASSET__B2e9w34b__"